import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CONFIRM_BUTTON,
  ERROR_TEXT,
  IMAGE_SRC,
  REJECT_BUTTON,
} from '../../shared-constants';
import { BUTTON_CLICK, WarningModalInput } from './warning-modal.constants';

@Component({
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss'],
  standalone: false,
})
export class WarningModalComponent {
  modalInput!: WarningModalInput;
  hasRejectButton: boolean;
  confirmText!: string;
  rejectText!: string;

  readonly buttonClick = BUTTON_CLICK;
  readonly ERROR_TEXT = ERROR_TEXT;
  readonly IMAGES = IMAGE_SRC;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: WarningModalInput,
    private dialogRef: MatDialogRef<WarningModalComponent>,
  ) {
    this.modalInput = data;
    this.hasRejectButton = data.rejectButtonText !== '';
    this.confirmText = data.confirmButtonText
      ? data.confirmButtonText
      : CONFIRM_BUTTON;
    this.rejectText = data.rejectButtonText
      ? data.rejectButtonText
      : REJECT_BUTTON;
  }

  onClose(button: BUTTON_CLICK): void {
    this.dialogRef.close({ button });
  }
}
